import "../styles/Accordion.css";

export function Accordion({label, header, opened, onClick, ...props}) {
    return <div className={"accordion" + (opened ? " opened" : "")} onClick={onClick}>
        <div className={"number font-body-M"}>({label})</div>
        <div className={"content"}>
            <h3>{header}</h3>
            <div className={"body"}>{props.children}</div>
        </div>
    </div>
}
